import styled from 'styled-components';
import { IFrame } from './interface';

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive === true ? 'flex' : 'none')};
  flex-wrap: wrap;
  width: ${(props) => (props.items ? `calc(100% / ${props.items})` : '100%')};
  justify-content: normal;
  @media (max-width: 994px) {
    flex-direction: column;
  }
  @media (min-width: 1024px) {
    > div {
      display: flex;
      -webkit-flex: 0 0 25%;
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: calc(25% - 1rem);
      margin-bottom: 25px;
      min-height: 340px;
      justify-content: space-between;
    }
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
